
/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit';

import axios from '../../utils/axios.js';
import { dispatch } from '../index';
import { handleError, handleSuccess } from '../../utils/apiResponseHandler.js';

const initialState = {
    error: null,
    messagingCampaigns: null,
    singleMessagingCampaign: null,
    loading: false,
    saveLoading: false,

    totalPages: null,
    totalCount: null,
};

const slice = createSlice({
    name: 'messagingCampaign',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        isLoading(state, action) {
            state.loading = action.payload;
        },

        isSaveLoading(state, action) {
            state.saveLoading = action.payload;
        },

        setMessagingCampaignDataSuccess(state, action) {
            state.messagingCampaigns = action.payload?.data;
            state.totalPages = action.payload?.totalPages;
            state.totalCount = action.payload?.totalCount;
        },

        setSingleMessagingCampaignDataSuccess(state, action) {
            state.singleMessagingCampaign = action.payload;
        },

        updateMessagingCampaignDataSuccess(state, action) {
            const index = state.messagingCampaigns.findIndex(messagingCampaign => messagingCampaign._id === action.payload.id);
            const apiKeyData = state.messagingCampaigns[index];
            const newData = { ...apiKeyData, ...action.payload.data };
            state.messagingCampaigns[index] = newData
        },

        createMessagingCampaignDataSuccess(state, action) {
            state.messagingCampaigns.push(action.payload);
        },

        // deleteMessagingCampaignDataSuccess(state, action) {
        //     const newMessagingCampaigns = state.messagingCampaigns.filter(messagingCampaign => messagingCampaign._id !== action.payload.id);
        //     state.messagingCampaigns = newMessagingCampaigns;
        // },
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------


export function getAllMessagingCampaigns({page, limit, search }) {
    return async () => {
        try {
            dispatch(slice.actions.isLoading(true))

            const response = await axios.get(`/messaging/getCampaignHistories?search=${search}`);
            dispatch(slice.actions.setMessagingCampaignDataSuccess(response?.data))

            return response?.data?.data;
        }
        catch (err) {
            handleError(err, dispatch);
        }
        finally {
            dispatch(slice.actions.isLoading(false))
        }
    }
}

export function createMessagingCampaign(data) {
    return async () => {
        try {
            dispatch(slice.actions.isSaveLoading(true))

            const response = await axios.post(`/messaging/createCampaign`, data);
            dispatch(slice.actions.createMessagingCampaignDataSuccess(response.data?.data))

            handleSuccess(response, "Messaging Campaign created successfully", dispatch);

            return response.data?.data;
        }
        catch (err) {
            handleError(err, dispatch);
            throw err
        }
        finally {
            dispatch(slice.actions.isSaveLoading(false))
        }
    }
}

export function updateMessagingCampaign(id, data) {
    return async () => {
        try {
            dispatch(slice.actions.isSaveLoading(true))

            const response = await axios.put(`/messaging/updateCampaing/${id}`, data);

            dispatch(slice.actions.updateMessagingCampaignDataSuccess(
                { data, id }
            ))
            handleSuccess(response, "Messaging Campaign updated successfully", dispatch);

            return response.data?.data;
        }
        catch (err) {
            handleError(err, dispatch);
            throw err
        }
        finally {
            dispatch(slice.actions.isSaveLoading(false))
        }
    }
}


// export function getAllMessagingCampaignLogs({ search = '', page, limit, start_date = '', end_date = '' }) {
//     return async () => {
//         try {
//             dispatch(slice.actions.isLoading(true))

//             const response = await axios.get(`/api_key/logs?search=${search}&start_date=${start_date}&end_date=${end_date}&page=${page}&limit=${limit}`);
//             dispatch(slice.actions.setMessagingCampaignLogDataSuccess(response?.data))

//             return response?.data?.data;
//         }
//         catch (err) {
//             handleError(err, dispatch);
//         }
//         finally {
//             dispatch(slice.actions.isLoading(false))
//         }
//     }
// }